import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';

import { CryptoPayout } from 'types/cryptoPayout';

import LABELS from './keys';
import { Item, ItemName, ItemValue, SecondaryItemValue, SectionWrapper } from './styles';

interface CryptoPayoutCustomerSectionProps {
  payout: CryptoPayout;
}

export const CryptoPayoutCustomerSection = ({ payout }: CryptoPayoutCustomerSectionProps) => {
  const { t } = useTranslation();

  return (
    <Panel label={t(LABELS.TITLE)}>
      <SectionWrapper>
        <Item>
          <ItemName>{t(LABELS.CUSTOMER_ID)}</ItemName>
          <SecondaryItemValue>{payout.customer.uuid}</SecondaryItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.CUSTOMER_EMAIL)}</ItemName>
          <ItemValue>{payout.customer.email}</ItemValue>
        </Item>
      </SectionWrapper>
    </Panel>
  );
};
